<template>
  <div id="app" class="page-wrapper">
    <main>
      <OrderFormHeader v-bind:formStatus="formStatus" v-bind:networkStatus="networkStatus"></OrderFormHeader>
      <OrderForm
        v-if="(isInitial || isFailed || isPending) && !isServiceRequestFailed"  />
    </main>
    <OrderFormFooter/>
  </div>
</template>

<script>
import OrderForm from './components/OrderForm.vue';
import OrderFormHeader from './components/OrderFormHeader.vue';
import OrderFormFooter from './components/OrderFormFooter.vue';

const STATUS_INITIAL = 0, STATUS_PENDING = 1, STATUS_SUCCESS = 2,
      STATUS_FAILED = 3, STATUS_SERVICE_UNAVAILABLE = 4, STATUS_SERVICE_REQUEST_FAILED = 5;

export default {
  name: 'app',

  created () {
    this.$eventHub.$on('updateFormStatus', value => {
      this.formStatus = value;
    });

    this.$eventHub.$on('updateNetworkStatus', value => {
      this.networkStatus = value;
    });
  },

  components: {
    OrderForm,
    OrderFormHeader,
    OrderFormFooter,
  },

  data () {
    return {
      headline: null,
      formStatus: 0,
      networkStatus: null,
    };
  },

  computed: {
    isInitial() {
      return this.formStatus === STATUS_INITIAL;
    },
    isPending() {
      return this.formStatus === STATUS_PENDING;
    },
    isSuccess() {
      return this.formStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.formStatus === STATUS_FAILED;
    },
    isServiceUnavailable() {
      return this.networkStatus === STATUS_SERVICE_UNAVAILABLE;
    },
    isServiceRequestFailed() {
      return this.networkStatus === STATUS_SERVICE_REQUEST_FAILED;
    },
  },

};
</script>

<style lang="scss">
.page-wrapper {
  max-width: 1680px;
  margin: 0 auto;
  background-color: #fff;
  background-image: linear-gradient(180deg, rgba(219, 228, 231, 0), #dbe4e7);

  // sticky footer
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  // sticky footer
  flex-grow: 1;
}

footer {
  // sticky footer
  flex-shrink: 0;
}
</style>
